import { render, staticRenderFns } from "./enquiries.vue?vue&type=template&id=4463be27&scoped=true&"
import script from "./enquiries.vue?vue&type=script&lang=js&"
export * from "./enquiries.vue?vue&type=script&lang=js&"
import style0 from "./enquiries.vue?vue&type=style&index=0&id=4463be27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4463be27",
  null
  
)

export default component.exports